import { Controller } from "@hotwired/stimulus"

// Toggles the application sidebar between its collapsed (icon-only) and
// expanded (icon + label) states. The choice is persisted in a cookie so it
// survives page reloads and Turbo navigations, and is rendered server-side
// on the <html> element to avoid a flash of the wrong width.
//
// While collapsed, it also drives the floating hover tooltip for each item.
// The tooltip uses `position: fixed` with coordinates computed here, so it
// is not clipped by the navigation area's `overflow` (which previously hid
// the tooltips for the scrollable story links).
export default class extends Controller {
  connect() {
    this.boundShow = this.showTip.bind(this)
    this.boundHide = this.hideActiveTip.bind(this)
    this.element.addEventListener("mouseover", this.boundShow)
    this.element.addEventListener("mouseleave", this.boundHide)
  }

  disconnect() {
    this.element.removeEventListener("mouseover", this.boundShow)
    this.element.removeEventListener("mouseleave", this.boundHide)
    this.hideActiveTip()
  }

  toggle() {
    const expanded = document.documentElement.classList.toggle("lz-sidebar-expanded")
    const oneYear = 60 * 60 * 24 * 365
    document.cookie = `lz_sidebar=${expanded ? "expanded" : "collapsed"}; path=/; max-age=${oneYear}; samesite=lax`
    this.hideActiveTip()
  }

  showTip(event) {
    if (document.documentElement.classList.contains("lz-sidebar-expanded")) {
      return this.hideActiveTip()
    }

    const item = event.target.closest(".lz-sb-item")
    const tip = item && item.querySelector(".lz-sb-tip")
    if (!tip) return this.hideActiveTip()
    if (tip === this.activeTip) return

    this.hideActiveTip()
    const rect = item.getBoundingClientRect()
    tip.style.top = `${rect.top + rect.height / 2}px`
    tip.style.left = `${rect.right + 8}px`
    tip.classList.add("lz-sb-tip-visible")
    this.activeTip = tip
  }

  hideActiveTip() {
    if (!this.activeTip) return
    this.activeTip.classList.remove("lz-sb-tip-visible")
    this.activeTip = null
  }
}
